module.exports = __webpack_public_path__ + "img/britecore_logo.3fe2c36b.svg";